/**
 * Created by akirilyuk on 9/8/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        BaseCollection = require("collections/BaseCollection"),
        TicketModel = require("connection-models/ticketTab/TicketModel"),
        AttachmentModel = require("connection-models/ticketTab/AttachmentModel"),
        AttachmentsCollection = {};
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var ATTACH_TYPES = {
        DEFAULT: 'default',
        LOGS: 'logs',
        FRAMEWORK: 'fw',
        CODE: 'code'
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        AttachmentsCollection = BaseCollection.extend({
            model: AttachmentModel,

            initialize: function (models, options) {
                if (options && options.ticketModel) {
                    this.ticketReference = options.ticketModel;
                }
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this.ticketReference, "change:" + TicketModel.KEYS.ATTACHMENTS, this._onAttachmentsChanged);
            },

            _onAttachmentsChanged: function () {
                this.reset(this.ticketReference.getAttachments());
            },

            deleteAttachment: function (attachment) {
                this.ticketReference.removeAttachment(attachment);
            },

            _addAttachment: function (attachment) {
                this.ticketReference.addUnsavedAttachment(attachment);
            },

            addEncodedAttachment: function (attachment) {
                if (this._userIsAllowedToAddAttachment()) {
                    this._addAttachment(attachment);
                    return true;
                }
                return false;
            },

            _userIsAllowedToAddAttachment: function () {
                return !this.ticketReference.isClosed(); // if case is closed -> no attachment upload is allowed
            }
        });
    });
    AttachmentsCollection.TYPES = ATTACH_TYPES;
    return AttachmentsCollection;
});

